export * from './get-web-location';
export * from './get-web-location-when-has-permission';
